module.exports = __webpack_public_path__ + "static/media/tallie.ab889d3e.jpg";